import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { LegalModal } from './LegalModal';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    type: 'privacy' | 'terms';
  }>({
    isOpen: false,
    type: 'privacy'
  });
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const openModal = (type: 'privacy' | 'terms') => {
    setModalConfig({
      isOpen: true,
      type
    });
  };
  const dummyContent = <>
      <p data-id="element-85">This is a placeholder for the legal document.</p>
      <p data-id="element-86">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.
      </p>
      <p data-id="element-87">
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </p>
    </>;
  return <footer className="bg-brand-navy-deep pt-20 pb-8" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-90">
          {/* Column 1 - Brand */}
          <div data-id="element-91">
            <div className="flex flex-col" data-id="element-92">
              <span className="font-script font-bold text-[32px] text-white leading-none" data-id="element-93">
                TwoGirls <span className="text-brand-gold" data-id="element-94">♡</span> MopCo
              </span>
              <span className="text-brand-gold font-montserrat font-medium text-[10px] tracking-[3px] mt-2" data-id="element-95">
                {t('brand.tagline')}
              </span>
              <div className="w-[60px] h-[1px] bg-brand-gold mt-4" data-id="element-96" />
            </div>
            <p className="font-inter text-white italic opacity-65 mt-6 text-sm leading-relaxed" data-id="element-97">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Column 2 - Services */}
          <div data-id="element-98">
            <h4 className="font-montserrat font-bold text-white text-lg mb-6" data-id="element-99">
              {t('footer.s.title')}
            </h4>
            <ul className="space-y-3" data-id="element-100">
              {['services.c1.title', 'services.c2.title', 'services.c3.title', 'services.c4.title', 'services.c5.title'].map((key, i) => <li key={i} data-id="element-101">
                  <button onClick={() => scrollTo('services')} className="font-inter text-white/75 hover:text-brand-gold transition-colors text-left text-sm" data-id="element-102">
                    {t(key)}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div data-id="element-103">
            <h4 className="font-montserrat font-bold text-white text-lg mb-6" data-id="element-104">
              {t('footer.c.title')}
            </h4>
            <ul className="space-y-4" data-id="element-105">
              <li className="flex items-center gap-3 text-white/80" data-id="element-106">
                <Phone size={16} className="text-brand-gold flex-shrink-0" data-id="element-107" />
                <a href="tel:7866603720" className="font-inter text-sm hover:text-brand-gold transition-colors" data-id="element-108">
                  (786) 660-3720
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80" data-id="element-109">
                <Phone size={16} className="text-brand-gold flex-shrink-0" data-id="element-110" />
                <a href="tel:7865602192" className="font-inter text-sm hover:text-brand-gold transition-colors" data-id="element-111">
                  (786) 560-2192
                </a>
                <span className="text-[11px] text-white/40 italic" data-id="element-112">
                  {t('footer.backup')}
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/80" data-id="element-113">
                <Mail size={16} className="text-brand-gold flex-shrink-0" data-id="element-114" />
                <a href="mailto:twomopgirlsco@gmail.com" className="font-inter text-sm hover:text-brand-gold transition-colors break-all" data-id="element-115">
                  twomopgirlsco@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80" data-id="element-116">
                <MapPin size={16} className="text-brand-gold flex-shrink-0" data-id="element-117" />
                <span className="font-inter text-sm" data-id="element-118">
                  Miami and Broward Area
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/80" data-id="element-119">
                <Clock size={16} className="text-brand-gold flex-shrink-0" data-id="element-120" />
                <span className="font-inter text-sm" data-id="element-121">{t('trust.hours')}</span>
              </li>
            </ul>
          </div>

          {/* Column 4 - Service Area */}
          <div data-id="element-122">
            <h4 className="font-montserrat font-bold text-white text-lg mb-6" data-id="element-123">
              {t('footer.a.title')}
            </h4>
            <p className="font-inter text-white/75 leading-relaxed text-sm" data-id="element-124">
              {t('footer.a.desc')}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-gold/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-125">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-126">
            <span className="font-inter text-white/50 text-sm" data-id="element-127">
              {t('footer.rights')}
            </span>
            <div className="flex gap-4" data-id="element-128">
              <button onClick={() => openModal('privacy')} className="font-inter text-white/50 hover:text-brand-gold text-sm transition-colors" data-id="element-129">
                {t('footer.privacy')}
              </button>
              <button onClick={() => openModal('terms')} className="font-inter text-white/50 hover:text-brand-gold text-sm transition-colors" data-id="element-130">
                {t('footer.terms')}
              </button>
            </div>
          </div>
          <span className="font-inter text-brand-gold text-sm font-medium" data-id="element-131">
            Website by Eleven Studio ✦
          </span>
        </div>
      </div>

      <LegalModal isOpen={modalConfig.isOpen} onClose={() => setModalConfig({
      ...modalConfig,
      isOpen: false
    })} title={modalConfig.type === 'privacy' ? t('footer.privacy') : t('footer.terms')} content={dummyContent} data-id="element-132" />
    </footer>;
};